import styled from "styled-components";

const MenuHeader = styled.h3`
  color: #fff;
  font-size: 13px;
  font-weight: bold;
  margin-bottom: 15px;
  margin-top: 0;
`; 
export default MenuHeader;